import type { PropsWithClassName } from '@fv/client-types'

import { InputGroupWrapper } from '@/components/inputs/InputGroup'

import { GLCodeSelector } from '../gl-codes/GLCodeSelector'
import { useAccountSettings } from '../settings/account-settings/hooks'
import { useBookingForm } from './hooks'

export const BookingFormGLCode = ({ className }: PropsWithClassName) => {
  const { glCode, setGLCode } = useBookingForm()
  const accountSettings = useAccountSettings()
  const required = accountSettings?.glCode?.required

  if (!accountSettings?.glCode?.enabled) return null

  return (
    <InputGroupWrapper
      className={className}
      label="GL Code"
      name="glCode"
      required={required}
    >
      <GLCodeSelector
        value={glCode}
        onChange={value => setGLCode(value ?? '')}
        required={required}
      />
    </InputGroupWrapper>
  )
}
